module.exports = __webpack_public_path__ + "media/entities/1206-d3a85bbf.png";